import { Notice } from "../Notice/index.js";
import "../Notice/Notice.toast.css";
import { jsx } from "react/jsx-runtime";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//#region src/NoticeCenter/index.tsx
const NoticeCenter = ({ duration = 3e3 }) => /* @__PURE__ */ jsx(ToastContainer, {
	className: "z-[9999]",
	containerId: "notice",
	draggable: false,
	closeOnClick: false,
	hideProgressBar: true,
	autoClose: duration,
	position: "top-right"
});
/**
* Показ toast-уведомления через NoticeCenter.
* @see https://www.figma.com/file/uRPlsieHFpRpRsYDX2KV1Q — UI Kit, уведомления
*/
const setNotice = (options) => {
	toast(Notice(options), {
		...options.config,
		theme: options.type === "bubble" ? "colored" : "light",
		containerId: "notice"
	});
};
//#endregion
export { NoticeCenter, setNotice };

//# sourceMappingURL=index.js.map